// import React from "react";
// import { Tabs, message } from "antd";
// import axios from "axios";
// import { useAuth } from "../context/auth";
// import { useApp } from "../context/appContext";
// import { useNavigate } from "react-router-dom";
// import Header3 from "../components/Header3";
// import Footer2 from "../components/Footer2";

// const NotificationPage = () => {
//   const navigate = useNavigate();

//   const { auth } = useAuth(); // ✅ useAuth() ko function ke bahar call karein
//   const user = auth?.user; // ✅ Prevent undefined errors

//   const { setLoading } = useApp();
//   const handleMarkAllRead = async () => {
//     // navigate(0);
//     try {
//       setLoading(true); // ✅ Start loading
//       const res = await axios.post(
//         "/api/v1/auth/get-all-notification",
//         { userId: auth.user._id },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       setLoading(false); // ✅ Stop loading
//       if (res.data.success) {
//         message.success(res.data.message);
//       } else {
//         message.error(res.data.message);
//       }
//     } catch (error) {
//       setLoading(false);
//       console.log(error);

//       if (error.response?.data?.message) {
//         message.error(error.response.data.message);
//       } else {
//         message.error("Something went wrong. Please try again.");
//       }
//     }
//   };

//   const handleDeleteAllRead = async () => {
//     // navigate(0);
//     try {
//       setLoading(true); // ✅ Start loading
//       const res = await axios.post(
//         "/api/v1/auth/delete-all-notification",
//         { userId: auth.user._id },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       setLoading(false); // ✅ Stop loading
//       if (res.data.success) {
//         message.success(res.data.message);
//       } else {
//         message.error(res.data.message);
//       }
//     } catch (error) {
//       setLoading(false); // ✅ Ensure loading stops on error
//       console.error(error);
//       message.error("Something went wrong in notification");
//     }
//   };

//   return (
//     <>
//       <Header3 />
//       <div className="container" style={{ height: "100vh" }}>
//         <h3 className="mt-4 text-center"> Notification</h3>
//         <Tabs className="m-2">
//           <Tabs.TabPane tab="unRead" key={0}>
//             <div className="d-flex justify-content-end">
//               <h4
//                 className="p-3"
//                 style={{ cursor: "pointer" }}
//                 onClick={handleMarkAllRead}
//               >
//                 {" "}
//                 Mark All Read
//               </h4>
//             </div>
//             {user?.notification.map((notificationMsg) => (
//               <div className="card" style={{ cursor: "pointer" }}>
//                 <div
//                   className="card-text"
//                   onClick={() => navigate(notificationMsg.onClickPath)}
//                 >
//                   {notificationMsg.message}
//                 </div>
//               </div>
//             ))}
//           </Tabs.TabPane>

//           <Tabs.TabPane tab="Read" key={1}>
//             <div className="d-flex justify-content-end">
//               <h4
//                 className="p-3 text-primany"
//                 style={{ cursor: "pointer" }}
//                 onClick={handleDeleteAllRead}
//               >
//                 {" "}
//                 Delete All Read
//               </h4>
//             </div>

//             {user?.seennotification.map((notificationMsg) => (
//               <div className="card" style={{ cursor: "pointer" }}>
//                 <div
//                   className="card-text"
//                   onClick={() => navigate(notificationMsg.onClickPath)}
//                 >
//                   {notificationMsg.message}
//                 </div>
//               </div>
//             ))}
//           </Tabs.TabPane>
//         </Tabs>
//       </div>
//       <Footer2 />
//     </>
//   );
// };

// export default NotificationPage;

// import { useContext } from "react";
// import { NotificationContext } from "../context/NotificationContext";

// const NotificationPage = () => {
//   const { notifications, setNotifications } = useContext(NotificationContext);

//   return (
//     <div>
//       <h2>🔔 Notifications</h2>
//       {notifications.length > 0 ? (
//         notifications.map((notif, index) => (
//           <div key={index} className="notification">
//             {notif.message}
//           </div>
//         ))
//       ) : (
//         <p>No new notifications</p>
//       )}
//       <button onClick={() => setNotifications([])}>Clear Notifications</button>
//     </div>
//   );
// };

// export default NotificationPage;

import React, { useContext } from "react";
import { Tabs, message } from "antd";
import { NotificationContext } from "../context/NotificationContext";
import { useNavigate } from "react-router-dom";
import Header3 from "../components/Header3";
import Footer2 from "../components/Footer2";
import { LanguageContext } from "../context/LanguageContext";
import { translateNotification } from "../utils/notificationTranslator";

const NotificationPage = () => {
  const navigate = useNavigate();
  const { notifications, setNotifications } = useContext(NotificationContext);
  const { lg } = useContext(LanguageContext);

  const handleMarkAllRead = () => {
    setNotifications([]); // ✅ Saare notifications remove ho jayenge
    message.success("All notifications marked as read.");
  };

  const handleDeleteAllRead = () => {
    setNotifications([]); // ✅ Purane notifications hata diye
    message.success("All read notifications deleted.");
  };

  return (
    <>
      <Header3 />
      <div className="container" style={{ height: "100vh" }}>
        <h3 className="mt-4 text-center">Notifications</h3>
        <Tabs className="m-2">
          <Tabs.TabPane tab="Unread" key="unread">
            <div className="d-flex justify-content-end">
              <h4
                className="p-3"
                style={{ cursor: "pointer" }}
                onClick={handleMarkAllRead}
              >
                Mark All Read
              </h4>
            </div>
            {notifications.length > 0 ? (
              // Ensure notifications are sorted by createdAt (newest first)
              [...notifications]
                .sort((a, b) => {
                  const dateA = new Date(a.createdAt || a.timestamp || 0);
                  const dateB = new Date(b.createdAt || b.timestamp || 0);
                  return dateB - dateA; // Newest first
                })
                .map((notification, index) => (
                  <div key={notification._id || index} className="card" style={{ cursor: "pointer" }}>
                  <div
                    className="card-text"
                      onClick={() => navigate(notification.onClickPath || "#")}
                  >
                    {translateNotification(notification.message, lg)}
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center">No unread notifications.</p>
            )}
          </Tabs.TabPane>

          <Tabs.TabPane tab="Read" key="read">
            <div className="d-flex justify-content-end">
              <h4
                className="p-3 text-danger"
                style={{ cursor: "pointer" }}
                onClick={handleDeleteAllRead}
              >
                Delete All Read
              </h4>
            </div>
            <p className="text-center">No read notifications.</p>
          </Tabs.TabPane>
        </Tabs>
      </div>
      <Footer2 />
    </>
  );
};

export default NotificationPage;
